"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewInspiredLogin extends new_item_1.default {
    constructor(newInspiredLogin) {
        super();
        this.username = newInspiredLogin.username;
        this.user = newInspiredLogin.user;
        this.token = newInspiredLogin.token;
        this.mfaRequired = newInspiredLogin.mfaRequired;
        this.expires = newInspiredLogin.expires;
        this.scope = newInspiredLogin.scope;
        this.tokenType = newInspiredLogin.tokenType;
    }
}
exports.default = NewInspiredLogin;
//# sourceMappingURL=new-inspiredLogin.js.map